import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { FlowScheduledTasksGrid, FlowScheduledTasksGridRow } from '~src/app/content/FlowScheduledTasksGrid';
import { getHeightForRows, SortableDataGrid } from '~src/common/react/components/dataGrid/SortableDataGrid3';
import { filePathDisplayStringWithoutBaseName } from '~src/common/utilities/FilePathUtils';
import { SliceableHelper } from '~src/ts/helpers/SliceableHelper';
import { FlowOutputStepInfo } from '~src/ts/models/FlowOutputStepInfo';
import { ISliceable } from '~src/ts/models/ISliceable';
import { FileConnectionDetail } from '~src/ts/ServerApi/types/ConnectionDetail';
import { IOrderClause } from '~src/ts/ServerApi/types/IOrderClause';

import { getConnectionText } from '../utils/FlowDataConnectionUtils';
import { getRefreshTypeDisplayText } from '../utils/FlowOutputStepUtils';

const SCROLLBAR_WIDTH: number = 20;

const outputDatagridStyle = style({
  border: `1px solid ${TabStyles.Colors.L6}`,
});

function getRowData(outputIds: ReadonlyArray<string>, outputSteps: ReadonlyArray<FlowOutputStepInfo>): (orderClause: IOrderClause[]) => ISliceable<FlowScheduledTasksGridRow> {
  const outputRows: FlowScheduledTasksGridRow[] = outputIds.map(outputId => {
    const outputInfo = outputSteps.find(step => step.id === outputId);
    const filePath: string = outputInfo && filePathDisplayStringWithoutBaseName((outputInfo.dataConnection.connectionDetails as FileConnectionDetail).fileName);
    const isIncremental = outputInfo && outputInfo.isIncremental;
    const outputOperationType = isIncremental ? outputInfo.incrementalOutputOperationType : outputInfo.outputOperationType;
    return outputInfo ? {
      outputStepName: outputInfo.name,
      outputName: outputInfo.datasourceName,
      outputType: outputInfo.dataConnection.connectionTypeDisplayName,
      outputLocation: filePath ? filePath : getConnectionText(outputInfo.dataConnection),
      outputRefreshType: getRefreshTypeDisplayText(isIncremental, outputOperationType)
    } : null;
  });
  return (_orderClause: IOrderClause[]) => SliceableHelper.fromArray(outputRows);
}

export interface FlowTaskOutputsGridProps {
  outputIds: ReadonlyArray<string>;
  outputSteps: ReadonlyArray<FlowOutputStepInfo>;
}

export function FlowTaskOutputsGrid(props: FlowTaskOutputsGridProps): JSX.Element {
  const sliceable = React.useMemo(
    () => getRowData(props.outputIds, props.outputSteps),
    [props.outputIds, props.outputSteps]
  );

  const columns = FlowScheduledTasksGrid.columns();
  return (
    <div className={outputDatagridStyle} style={{ height: getHeightForRows(props.outputSteps.length + 1) - 3 + SCROLLBAR_WIDTH}}>
      <SortableDataGrid
        columns={columns}
        getSliceable={sliceable}
      />
    </div>
  );
}